// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.public',
    path: 'my/PartnerApplication',
    name: 'UserPartnerList',
    component: () => import('./PgUserPartnerList'),
    meta: {
      title: '合作夥伴申請',
      authenticated: true
    }
  }
]
